<template>
    <div class="page" @click="cancelSearch($event)">
        <!-- <img class="top-logo" src="~@/assets/daily-market/bg.png" alt="" /> -->
        <div class="scroller">
            <div class="query-box">
                <div class="title">
                    <img
                        src="~@/assets/daily-market/title-left-line.png"
                        alt=""
                    />
                    <span>个股查询永久免费</span>
                    <img
                        src="~@/assets/daily-market/title-right-line.png"
                        alt=""
                    />
                </div>
                <div>
                    <div class="input-box">
                        <img
                            class="search-logo"
                            src="~@/assets/daily-market/search-logo.png"
                            alt=""
                        />
                        <div class="line"></div>
                        <input
                            type="text"
                            v-model="keyword"
                            placeholder="输入股票名称/代码"
                            @input="changeCodeList()"
                            @focus="focus"
                        />
                        <div
                            class="code-list"
                            :class="[visible ? 'active' : '']"
                        >
                            <div
                                class="item"
                                v-for="item in newList"
                                :key="item.code"
                                @click="replace(item)"
                            >
                                <span class="name"> {{ item.sec_name }}</span>
                                <span class="code"> {{ item.code }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="intro">
                        擒龙头、抓拐点、看趋势、个股潜力六大维度一键查询
                    </div>
                </div>
            </div>
            <div class="comments">
                <div class="title">
                    <img
                        src="~@/assets/daily-market/title-left-line.png"
                        alt=""
                    />
                    <span>市场风向热评</span>
                    <img
                        src="~@/assets/daily-market/title-right-line.png"
                        alt=""
                    />
                </div>
                <div class="content">
                    {{ content }}
                </div>
                <div class="jz dialog-box left">
                    <div class="left">
                        <img
                            class="logo"
                            src="~@/assets/daily-market/jz.png"
                            alt=""
                        />
                        <div>神棍局长</div>
                    </div>
                    <div class="right">
                        {{ juzhang }}
                    </div>
                </div>
                <div class="pg dialog-box right">
                    <div class="right">
                        {{ paoge }}
                    </div>
                    <div class="left">
                        <img
                            class="logo"
                            src="~@/assets/daily-market/pg.png"
                            alt=""
                        />
                        <div>庖哥</div>
                    </div>
                </div>
            </div>
            <div class="fg"></div>
            <div class="trump-program">
                <div class="title">
                    <img src="~@/assets/daily-market/trump-logo.png" alt="" />
                    <span>王牌栏目</span>
                    <span class="notice">新用户免费体验</span>
                </div>
                <div class="list">
                    <a
                        class="item"
                        href=" https://lianghua.nbd.com.cn/emotionHtml_new/index?app_channel=eightwd"
                    >
                        <div class="top">
                            <span>免费体验一周</span>
                        </div>
                        <div class="content">
                            <div class="left">
                                <div class="name">情绪宝</div>
                                <div class="intro">投资首先看清风向</div>
                            </div>
                            <img
                                class="right"
                                src="~@/assets/daily-market/qxb-logo.png"
                                alt=""
                            />
                        </div>
                        <div class="price-box">
                            <!-- <span>
                                ￥229
                                <b>/年</b>
                            </span> -->
                        </div>
                    </a>
                    <router-link
                        to="/course-detail/06D0F5068EFBC1C42C46E7E662464C89/STUDY?app_channel=eightwd"
                        class="item"
                    >
                        <div class="top">
                            <span>免费体验一周</span>
                        </div>
                        <div class="content">
                            <div class="left">
                                <div class="name">钱瞻研报</div>
                                <div class="intro">专业研报中挑干货</div>
                            </div>
                            <img
                                class="right"
                                src="~@/assets/daily-market/qianyan-logo.png"
                                alt=""
                            />
                        </div>
                        <div class="price-box">
                            <!-- <span>
                                ￥18
                                <b>/期</b>
                            </span> -->
                        </div>
                    </router-link>
                    <router-link
                        to="/course-detail/D3869466DAB7590C85B1DDB08A94314F/EVENING_PAPER?app_channel=eightwd"
                        class="item"
                    >
                        <div class="top">
                            <span>免费体验一周</span>
                        </div>
                        <div class="content">
                            <div class="left">
                                <div class="name">每日夜报</div>
                                <div class="intro">百份公告中寻机会</div>
                            </div>
                            <img
                                class="right"
                                src="~@/assets/daily-market/yebao-logo.png"
                                alt=""
                            />
                        </div>
                        <div class="price-box">
                            <!-- <span>
                                ￥668
                                <b>/年</b>
                            </span> -->
                        </div>
                    </router-link>
                    <router-link
                        to="/course-detail/884D85A98AB953C8EA04B84C754B0165/STUDY?app_channel=eightwd"
                        class="item"
                    >
                        <div class="top">
                            <span>免费体验一期</span>
                        </div>
                        <div class="content">
                            <div class="left">
                                <div class="name">股月奇谈</div>
                                <div class="intro">先人一步看市场</div>
                            </div>
                            <img
                                class="right"
                                src="~@/assets/daily-market/guyue-logo.png"
                                alt=""
                            />
                        </div>
                        <div class="price-box">
                            <!-- <span>
                                ￥88
                                <b>/期</b>
                            </span> -->
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="touzi">
                <div class="title">
                    <img
                        class="touzi-logo"
                        src="~@/assets/daily-market/touzi-logo.png"
                        alt=""
                    />
                    <span>投资技能提升</span>
                </div>
                <div class="list">
                    <div
                        class="item"
                        v-for="(item, index) in sale"
                        :key="index"
                    >
                        <div
                            class="left"
                            :style="{
                                background:
                                    'url(' +
                                    item.adImg +
                                    ') no-repeat center/100% 100%',
                            }"
                        ></div>
                        <div class="right">
                            <div class="name">{{ item.title }}</div>
                            <div class="intro">
                                {{ item.brief }}
                            </div>
                            <div class="btns">
                                <router-link
                                    class="price-box"
                                    v-for="priceObj in item.price"
                                    :key="priceObj.id"
                                    :to="priceObj.link"
                                >
                                    <span class="num">
                                        {{ priceObj.episodeNum }}
                                    </span>
                                    <span class="price">
                                        ￥{{ priceObj.price }}
                                    </span>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <img
                class="qrcode"
                src="~@/assets/daily-market/qrcode.png"
                alt=""
            />
        </div>
        <footer class="fixed-footer">
            <div class="left">
                <div class="origin-price">
                    <span>原价：</span>
                    <span>4235/年</span>
                </div>
                <div class="sale-price">
                    <span>现价：</span>
                    <span>￥ 3388/年</span>
                </div>
            </div>
            <img
                @click="go_xy()"
                src="~@/assets/daily-market/go-detail.png"
                alt=""
            />
        </footer>
        <div class="zz" :class="[isShowModel ? 'active' : '']">
            <div class="model-container">
                <div class="model">
                    <img
                        class="model-notice"
                        src="~@/assets/daily-market/model-notice.png"
                        alt=""
                    />
                    <img
                        class="get-btn"
                        src="~@/assets/daily-market/get-btn.png"
                        alt=""
                        @click="firstIn()"
                    />
                </div>
                <img
                    class="close"
                    src="~@/assets/daily-market/close.png"
                    alt=""
                    @click="close()"
                />
            </div>
        </div>
    </div>
</template>

<script>
import PinyinEngine from "pinyin-engine";
import dailtMarketService from "../../service/daily-market";
import { Toast } from "vant";
export default {
    name: "daily-market",
    data() {
        return {
            allData: [],
            keyword: "",
            newList: [],
            timer: null,
            visible: false,
            pinyinEngine: null,
            content: "",
            juzhang: "",
            paoge: "",
            sale: [],
            isShowModel: false,
        };
    },
    created() {
        this.getAllCodeAndName();
        this.getTodayYelp();
    },
    mounted() {
        document.addEventListener("resize", this.dealIosInput);
        document.addEventListener("focusout", this.dealIosInput);
        window.addEventListener("pagehide", this.historyBack);
        this.ifHasIn();
    },
    methods: {
        historyBack() {
            this.keyword = "";
        },
        firstIn() {
            dailtMarketService.firstIn().then((res) => {
                Toast(res.data);
                this.isShowModel = false;
            });
        },
        ifHasIn() {
            dailtMarketService.ifHasIn().then((res) => {
                if (!res.data.ifIn) {
                    setTimeout(() => {
                        this.isShowModel = true;
                    }, 2000);
                }
            });
        },
        close() {
            this.isShowModel = false;
        },
        go_xy() {
            this.$router.push("/index");
        },
        getTodayYelp() {
            dailtMarketService.getTodayYelp().then((res) => {
                this.content = res.data.content;
                this.juzhang = res.data.juzhang;
                this.paoge = res.data.paoge;
                this.sale = res.data.sale;
            });
        },
        dealIosInput() {
            let scrollTop =
                document.body.scrollTop || document.documentElement.scrollTop;
            window.scrollTo(0, scrollTop + 100);
            window.scrollTo(0, scrollTop);
        },
        cancelSearch(e) {
            let target = e.target;
            while (
                target.classList &&
                !Array.from(target.classList).includes("code-list")
            ) {
                target = target.parentNode;
                if (Array.from(target.classList).includes("input-box")) {
                    break;
                }
                if (
                    Array.from(target.classList).includes("page") ||
                    target.nodeName == "BODY" ||
                    target.nodeName == "HTML"
                ) {
                    this.visible = false;
                    break;
                }
            }
        },
        getAllCodeAndName() {
            dailtMarketService.getAllCodeAndName().then((res) => {
                this.allData = res.data;
                this.pinyinEngine = new PinyinEngine(this.allData, [
                    "sec_name",
                ]);
            });
        },
        changeCodeList() {
            this.queryCode();
        },
        replace(item) {
            var index = item.code.indexOf(".");
            var stockCode = item.code.slice(0, index);
            var stockName = item.sec_name;
            this.keyword = item.sec_name + "/" + stockCode;
            localStorage.setItem(
                "keyword",
                JSON.stringify({
                    stockCode,
                    stockName,
                })
            );
            this.visible = !this.visible;
            document.removeEventListener("resize", this.dealIosInput);
            document.removeEventListener("focusout", this.dealIosInput);
            // location.href = `http://lianghua.nbd.com.cn/eightwd/index?stockCode=${stockCode}&stockName=${stockName}`;
            // location.href = `http://localhost:4400/index?stockCode=${stockCode}&stockName=${stockName}`;
            this.$router.push(
                `/stock-six-dimension?stockName=${stockName}&stockCode=${stockCode}`
            );
        },
        // },
        queryCode() {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                let arr = [];
                let keyword = this.keyword;
                if (/^[0-9]*$|\/[0-9]*$/.test(this.keyword)) {
                    arr = this.allData.filter((item) => {
                        if (keyword.indexOf("/") != -1) {
                            let str = item.sec_name + "/" + item.code;
                            if (str.indexOf(keyword) != -1) {
                                return true;
                            }
                        } else {
                            if (item.code.indexOf(keyword) != -1) {
                                return true;
                            }
                        }
                    });
                } else {
                    arr = this.allData.filter((item) => {
                        if (item.sec_name.indexOf(keyword) != -1) {
                            return true;
                        }
                    });
                    arr = this.pinyinEngine.query(keyword);
                }

                this.newList = arr.slice(0, 5);
                this.visible = true;
            }, 200);
        },
        focus() {
            if (this.keyword) {
                this.queryCode();
            } else {
                this.newList = this.allData.slice(0, 5);
                this.visible = true;
            }
        },
    },
};
</script>

<style lang="scss" scoped src="./daily-market.scss">
</style>